import React from 'react'

const Manual_activar_config_subcategoria_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Activar Configuración de Subcategoría para Clau
        </h2>
        <iframe
          src="https://scribehow.com/embed/Activar_Configuracion_de_Subcategoria_para_Clau__x1dmaLTQQR25EIiDJryUuA?as=scrollable"
          className="scribe-iframe-general-181"
          width="100%"
          height="4200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_activar_config_subcategoria_clau
